import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UserDataService } from 'src/services/user-data.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  userDataSubscription: Subscription;
  userData: any;
  constructor(private router: Router, private userDataService: UserDataService) {}

  ngOnInit() {
    this.userDataSubscription = this.userDataService.getUserData().subscribe((user) => {
      this.userData = user;
    });
  }

  ngOnDestroy() {
    this.userDataSubscription.unsubscribe();
  }
}
